export default function IntegerFilter(value) {
    let _val = 0.00;
    if (typeof value === 'string') {
        _val = parseFloat(value);
    } else {
        _val = value;
    }
    return _val.toFixed(0);
}
